import React, { useState, useEffect } from 'react';
import { Dialog } from 'primereact/dialog';
import { Calendar } from 'primereact/calendar';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { Badge } from 'primereact/badge';
import { Chip } from 'primereact/chip';
import { Rating } from 'primereact/rating';
import { MapContainer, TileLayer, Marker, Popup, useMapEvents, Circle } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import './UnidadesDisponiblesModal.scss';
import { extraerHoraDate, extraerHoraDeDate } from '../../../../utilities/formateos';
import { getUnidadesDisponiblesAPI } from '../MaestroDeServiciosIntegracion';
import { Dropdown } from 'primereact/dropdown';
import Swal from 'sweetalert2';

// Fix para los iconos de Leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

const UnidadesDisponiblesModal = ({ visible, onHide, fecha, tiposUnidades }) => {
    // Crear fechas con hora 00:00:00
    const horaInicioDefault = new Date();
    horaInicioDefault.setHours(0, 0, 0, 0);
    
    const horaFinDefault = new Date();
    horaFinDefault.setHours(0, 0, 0, 0);

    const [horaInicio, setHoraInicio] = useState(horaInicioDefault);
    const [horaFin, setHoraFin] = useState(horaFinDefault);
    const [unidades, setUnidades] = useState([]);
    const [tipoUnidad, setTipoUnidad] = useState();
    const [selectedPoint, setSelectedPoint] = useState(null);
    const [selectedUnidad, setSelectedUnidad] = useState(null);
    const [mapCenter, setMapCenter] = useState([20.6597, -103.3496]); // Guadalajara
    const [isSearching, setIsSearching] = useState(false);

    console.log("hora_inicio", fecha + ' ' + extraerHoraDate(horaInicio));
    console.log("horaFin", fecha + ' ' + extraerHoraDate(horaFin));
    console.log("fecha", fecha);


    // Componente para manejar clicks en el mapa
    const MapClickHandler = () => {
        useMapEvents({
            click: (e) => {
                const { lat, lng } = e.latlng;
                setSelectedPoint({ lat, lng });
                calcularDistanciasYOrdenar({ lat, lng });
            },
        });
        return null;
    };

    // Función para calcular distancia entre dos puntos (Haversine)
    const calcularDistancia = (lat1, lon1, lat2, lon2) => {
        const R = 6371; // Radio de la Tierra en km
        const dLat = (lat2 - lat1) * Math.PI / 180;
        const dLon = (lon2 - lon1) * Math.PI / 180;
        const a =
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
            Math.sin(dLon / 2) * Math.sin(dLon / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        return R * c;
    };

    // Función para ordenar unidades por distancia
    const calcularDistanciasYOrdenar = (punto) => {
        if (!punto?.lat || !punto?.lng) return;

        const unidadesConDistancia = unidades
            .filter(unidad => unidad?.latitud && unidad?.longitud) // Filtrar unidades con coordenadas válidas
            .map(unidad => ({
                ...unidad,
                distancia: calcularDistancia(
                    punto.lat,
                    punto.lng,
                    unidad.latitud,
                    unidad.longitud
                )
            }));

        const unidadesOrdenadas = unidadesConDistancia.sort((a, b) => a.distancia - b.distancia);
        setUnidades(unidadesOrdenadas);
    };

    // Función para consultar unidades (placeholder para API)
    const consultarUnidades = async () => {
        // Validar fecha
        if (!fecha) {
            Swal.fire({
                icon: 'warning',
                title: 'Fecha requerida',
                text: 'Por favor selecciona una fecha para buscar unidades disponibles',
                confirmButtonText: 'Entendido',
                confirmButtonColor: '#667eea'
            });
            return;
        }

        // Validar hora de inicio
        if (!horaInicio) {
            Swal.fire({
                icon: 'warning',
                title: 'Hora de inicio requerida',
                text: 'Por favor selecciona la hora de inicio del servicio',
                confirmButtonText: 'Entendido',
                confirmButtonColor: '#667eea'
            });
            return;
        }

        // Validar hora de fin
        if (!horaFin) {
            Swal.fire({
                icon: 'warning',
                title: 'Hora de fin requerida',
                text: 'Por favor selecciona la hora de fin del servicio',
                confirmButtonText: 'Entendido',
                confirmButtonColor: '#667eea'
            });
            return;
        }

        // Validar tipo de unidad
        if (!tipoUnidad) {
            Swal.fire({
                icon: 'warning',
                title: 'Tipo de unidad requerido',
                text: 'Por favor selecciona el tipo de unidad que necesitas',
                confirmButtonText: 'Entendido',
                confirmButtonColor: '#667eea'
            });
            return;
        }

        console.log("hora_inicio", fecha + ' ' + extraerHoraDate(horaInicio));
        console.log("horaFin", fecha + ' ' + extraerHoraDate(horaFin));
        console.log("fecha", fecha);
        console.log("tipoUnidad", tipoUnidad);

        setIsSearching(true);

        try {
            // Función callback para procesar las unidades después de obtenerlas
            const procesarUnidades = (unidadesObtenidas) => {
                // Si ya hay un punto seleccionado, calcular distancias
                if (selectedPoint?.lat && selectedPoint?.lng) {
                    const unidadesConDistancia = unidadesObtenidas
                        .filter(unidad => unidad?.latitud && unidad?.longitud)
                        .map(unidad => ({
                            ...unidad,
                            distancia: calcularDistancia(
                                selectedPoint.lat,
                                selectedPoint.lng,
                                unidad.latitud,
                                unidad.longitud
                            )
                        }));
                    
                    const unidadesOrdenadas = unidadesConDistancia.sort((a, b) => a.distancia - b.distancia);
                    setUnidades(unidadesOrdenadas);
                } else {
                    // Si no hay punto, solo establecer las unidades
                    setUnidades(unidadesObtenidas);
                }
            };

            await getUnidadesDisponiblesAPI(
                procesarUnidades, 
                fecha, 
                fecha + ' ' + extraerHoraDate(horaInicio), 
                fecha + ' ' + extraerHoraDate(horaFin),
                tipoUnidad?.code || null
            );

        } catch (error) {
            console.error('Error al consultar unidades:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error al buscar unidades',
                text: 'Ocurrió un error al consultar las unidades disponibles. Por favor intenta nuevamente.',
                confirmButtonText: 'Entendido',
                confirmButtonColor: '#667eea'
            });
        } finally {
            setIsSearching(false);
        }
    };

    // Función para limpiar todos los campos
    const limpiarCampos = () => {
        const nuevaHoraInicio = new Date();
        nuevaHoraInicio.setHours(0, 0, 0, 0);
        
        const nuevaHoraFin = new Date();
        nuevaHoraFin.setHours(0, 0, 0, 0);

        setHoraInicio(nuevaHoraInicio);
        setHoraFin(nuevaHoraFin);
        setTipoUnidad(null);
        setUnidades([]);
        setSelectedPoint(null);
        setSelectedUnidad(null);
        setMapCenter([20.6597, -103.3496]); // Guadalajara
    };

    // Icono personalizado para punto seleccionado
    const selectedIcon = new L.Icon({
        iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-red.png',
        shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowSize: [41, 41]
    });

    // Icono para unidades
    const unidadIcon = new L.Icon({
        iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-blue.png',
        shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowSize: [41, 41]
    });

    // Icono para unidad seleccionada
    const selectedUnidadIcon = new L.Icon({
        iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-green.png',
        shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowSize: [41, 41]
    });

    // Función para manejar la selección de unidad
    const handleSelectUnidad = (unidad) => {
        setSelectedUnidad(unidad);
        // Solo centrar el mapa si la unidad tiene coordenadas válidas
        if (unidad?.latitud && unidad?.longitud) {
            setMapCenter([unidad.latitud, unidad.longitud]);
        }
        console.log('Unidad seleccionada:', unidad);
    };

    const renderFooter = () => {
        return (
            <div className="unidades-modal-footer">
                <Button
                    label="Cerrar"
                    icon="pi pi-times"
                    onClick={onHide}
                    className="p-button-text p-button-secondary unidades-modal-close-btn"
                    outlined
                />
            </div>
        );
    };


    return (
        <Dialog
            header={
                <div className="dialog-header-custom">
                    <div className="header-icon">
                        <i className="pi pi-car"></i>
                    </div>
                    <div className="header-text">
                        <h2>Unidades Disponibles</h2>
                        <p>Encuentra la unidad perfecta para tu servicio</p>
                    </div>
                </div>
            }
            visible={visible}
            style={{ width: '95vw', height: '95vh' }}
            onHide={onHide}
            footer={renderFooter}
            maximizable
            className="unidades-dialog-custom"
        >
            <div className="unidades-disponibles-container">
                {/* Filtros de tiempo más compactos */}
                <div className="filtros-tiempo">
                    <div className="filtros-content">
                        <div className="p-field">
                            <label htmlFor="horaInicio">
                                <i className="pi pi-clock"></i>
                                Inicio
                            </label>
                            <Calendar
                                id="horaInicio"
                                value={horaInicio}
                                onChange={(e) => setHoraInicio(e.value)}
                                timeOnly
                                hourFormat="24"
                                placeholder="00:00"
                                showIcon
                            />
                        </div>
                        <div className="time-separator">
                            <i className="pi pi-arrow-right"></i>
                        </div>
                        <div className="p-field">
                            <label htmlFor="horaFin">
                                <i className="pi pi-clock"></i>
                                Fin
                            </label>
                            <Calendar
                                id="horaFin"
                                value={horaFin}
                                onChange={(e) => setHoraFin(e.value)}
                                timeOnly
                                hourFormat="24"
                                placeholder="23:59"
                                showIcon
                            />
                        </div>
                        <div className="time-separator">
                            <i className="pi pi-arrow-right"></i>
                        </div>
                        <div className="p-field">
                            <label htmlFor="tipoUnidad">
                                <i className="pi pi-truck"></i>
                                Tipo Unidad
                            </label>
                            <div className="filter-field">
                                <Dropdown filter optionLabel='name' id="tipoUnidad" value={tipoUnidad} options={tiposUnidades} onChange={(e) => setTipoUnidad(e.value)} placeholder="Tipo Unidad" />
                            </div>
                        </div>
                        <Button
                            label="Buscar"
                            icon={isSearching ? "pi pi-spin pi-spinner" : "pi pi-search"}
                            onClick={consultarUnidades}
                            className="search-button"
                            disabled={isSearching}
                        />
                        <Button
                            label="Limpiar"
                            icon="pi pi-times"
                            onClick={limpiarCampos}
                            className="p-button-outlined p-button-secondary"
                            disabled={isSearching}
                        />
                    </div>
                </div>

                <div className="contenido-principal">
                    {/* Mapa con header más compacto */}
                    <div className="mapa-container">
                        <div className="mapa-header">
                            <div className="mapa-title">
                                <i className="pi pi-map"></i>
                                <span>Mapa Interactivo</span>
                            </div>
                            {unidades.length > 0 && (
                                <span className="unidades-chip">
                                    {unidades.length} unidades
                                </span>
                            )}
                        </div>
                        <div className="mapa-instrucciones">
                            <i className="pi pi-info-circle"></i>
                            <span>Haz clic en el mapa para ordenar unidades por cercanía</span>
                        </div>
                        <div className="map-wrapper">
                            <MapContainer
                                center={mapCenter}
                                zoom={13}
                                style={{ height: '100%', width: '100%', borderRadius: '0 0 12px 12px' }}
                                key={`${mapCenter[0]}-${mapCenter[1]}`}
                            >
                                <TileLayer
                                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
                                />
                                <MapClickHandler />

                                {selectedPoint && (
                                    <>
                                        <Circle
                                            center={[selectedPoint.lat, selectedPoint.lng]}
                                            radius={500}
                                            pathOptions={{
                                                color: '#667eea',
                                                fillColor: '#667eea',
                                                fillOpacity: 0.1
                                            }}
                                        />
                                        <Marker position={[selectedPoint.lat, selectedPoint.lng]} icon={selectedIcon}>
                                            <Popup>
                                                <div className="custom-popup">
                                                    <strong>📍 Punto seleccionado</strong><br />
                                                    <small>Lat: {selectedPoint.lat.toFixed(4)}</small><br />
                                                    <small>Lng: {selectedPoint.lng.toFixed(4)}</small>
                                                </div>
                                            </Popup>
                                        </Marker>
                                    </>
                                )}

                                {unidades
                                    .filter(unidad => unidad?.latitud && unidad?.longitud) // Filtrar unidades con coordenadas válidas
                                    .map((unidad) => (
                                    <Marker
                                        key={unidad.id}
                                        position={[unidad.latitud, unidad.longitud]}
                                        icon={selectedUnidad?.id === unidad.id ? selectedUnidadIcon : unidadIcon}
                                    >
                                        <Popup>
                                            <div className="custom-popup">
                                                <strong>🚗 Unidad {unidad.numero}</strong><br />
                                                <small>Tipo: {unidad.tipo}</small><br />
                                                <small>Capacidad: {unidad.CAPACIDAD}</small><br />
                                                {unidad.distancia > 0 && (
                                                    <small className="distancia-popup">
                                                        📏 {unidad.distancia.toFixed(2)} km
                                                    </small>
                                                )}
                                            </div>
                                        </Popup>
                                    </Marker>
                                ))}
                            </MapContainer>
                        </div>
                    </div>

                    {/* Cards de unidades mejoradas */}
                    <div className="unidades-lista">
                        <div className="unidades-lista-header glass-effect">
                            <h3>
                                <i className="pi pi-list"></i>
                                Unidades Disponibles
                            </h3>
                            {selectedUnidad && (
                                <span className="unidades-chip" >
                                    Unidad {selectedUnidad.numero} seleccionada
                                </span>
                            )}
                        </div>

                        {unidades.length === 0 ? (
                            <div className="sin-resultados glass-effect">
                                <div className="empty-state">
                                    <i className="pi pi-inbox"></i>
                                    <h3>Sin resultados</h3>
                                    <p>Selecciona un rango de horas y busca unidades disponibles</p>
                                </div>
                            </div>
                        ) : (
                            <div className="unidades-grid">
                                {unidades.map((unidad, index) => (
                                    <Card
                                        key={unidad.id}
                                        className={`unidad-card-modern ${selectedUnidad?.id === unidad.id ? 'unidad-card-selected' : ''}`}
                                    >
                                        <div className="unidad-card-content">
                                            <div className="unidad-imagen-container">
                                                <img
                                                    src={`https://repo.sumaenlinea.mx/e_Web/${unidad.imagen}`}
                                                    alt={`Unidad ${unidad.numero}`}
                                                    className="unidad-imagen"
                                                />
                                                {selectedUnidad?.id === unidad.id && (
                                                    <div className="unidad-selected-badge">
                                                        <i className="pi pi-check-circle"></i>
                                                    </div>
                                                )}
                                                <div className="unidad-tipo-overlay">
                                                    {unidad.tipo}
                                                </div>
                                            </div>

                                            <div className="unidad-info-wrapper">
                                                {/* Sección principal */}
                                                <div className="unidad-header-section">
                                                    <div className="unidad-title-group">
                                                        <h3 className="unidad-numero">Unidad {unidad.numero}</h3>
                                                        <span className="unidad-id">ID: {unidad.id}</span>
                                                    </div>
                                                    {unidad.NOMBRE_CHOFER && (
                                                        <div className="operador-badge">
                                                            <i className="pi pi-user"></i>
                                                            <span>{unidad.NOMBRE_CHOFER}</span>
                                                        </div>
                                                    )}
                                                </div>

                                                {/* Grid de información */}
                                                <div className="unidad-info-grid-modern">
                                                    {/* Calificación y capacidad */}
                                                    <div className="info-group">
                                                       
                                                        <div className="info-badge" title="Capacidad de pasajeros">
                                                            <i className="pi pi-users"></i>
                                                            <span>{unidad.CAPACIDAD}</span>
                                                        </div>
                                                    </div>

                                                    {/* Modelo, antigüedad del chofer y estado */}
                                                    <div className="info-group">
                                                        {unidad.MODELO && (
                                                            <div className="info-badge" title="Año del modelo de la unidad">
                                                                <i className="pi pi-calendar"></i>
                                                                <span>Año: {unidad.MODELO}</span>
                                                            </div>
                                                        )}
                                                         {unidad.NIVEL !== undefined && unidad.NIVEL !== null && (
                                                            <div className="info-badge rating-badge" title="Calificación del operador">
                                                                <Rating 
                                                                    value={unidad.NIVEL} 
                                                                    readOnly 
                                                                    cancel={false} 
                                                                    stars={5}
                                                                    className="rating-inline"
                                                                    color='#ff6f00'
                                                                />
                                                            </div>
                                                        )}
                                                        {unidad.ANTIGUEDAD && (
                                                            <div className="info-badge antiguedad-badge" title="Antigüedad del operador en la empresa">
                                                                <i className="pi pi-clock"></i>
                                                                <span>{unidad.ANTIGUEDAD}</span>
                                                            </div>
                                                        )}
                                                        <div className={`info-badge status-badge ${unidad.disponible ? 'disponible' : 'no-disponible'}`} title="Estado de disponibilidad de la unidad">
                                                            <i className="pi pi-circle-fill"></i>
                                                            <span>{unidad.disponible ? 'Disponible' : 'Ocupada'}</span>
                                                        </div>
                                                    </div>

                                                    {/* Distancia si existe */}
                                                    {unidad.distancia > 0 && (
                                                        <div className="info-group">
                                                            <div className="info-badge distance-badge" title="Distancia desde el punto seleccionado en el mapa">
                                                                <i className="pi pi-map-marker"></i>
                                                                <span>A {unidad.distancia.toFixed(1)} km</span>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>

                                                {/* Botón de acción */}
                                                <div className="unidad-action-modern">
                                                    <Button
                                                        icon={selectedUnidad?.id === unidad.id ? "pi pi-check" : "pi pi-plus"}
                                                        className={`action-btn ${selectedUnidad?.id === unidad.id ? 'selected' : ''}`}
                                                        onClick={() => handleSelectUnidad(unidad)}
                                                        tooltip={selectedUnidad?.id === unidad.id ? "Seleccionada" : "Seleccionar unidad"}
                                                        tooltipOptions={{ position: 'top' }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </Card>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </Dialog>
    );
};

export default UnidadesDisponiblesModal;
